import { defaultTimeZone, defaultLocales } from './constants';
import { isDate } from './isDate';
import { isInvalidDate } from './isInvalidDate';

/**
 * Converts a Date object into a date only string formatted to ISO8601.
 *
 * e.g. 2021-06-03
 * @param {*} date a Date object you want to convert into a string - gracefully handles any input
 * @param {object} options -
 * @param {string} options.timeZone - the timezone you want date displayed in, defaults to current users time zone
 * @returns {string} a formatted date string
 */
export const dateOnlyISOString = (
  date: unknown,
  { timeZone = defaultTimeZone }: DateOnlyStringOptions = {},
): string => {
  if (!isDate(date) || isInvalidDate(date)) {
    return '';
  }

  try {
    const formatter = new Intl.DateTimeFormat(defaultLocales, {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      timeZone,
    });
    const parts = formatter.formatToParts(date);
    const partsAsObject = parts.reduce(
      (map: Partial<Record<Intl.DateTimeFormatPartTypes, string>>, obj) => {
        // eslint-disable-next-line no-param-reassign
        map[obj.type] = obj.value;
        return map;
      },
      {},
    ) as Record<Intl.DateTimeFormatPartTypes, string>;
    return `${partsAsObject.year}-${partsAsObject.month}-${partsAsObject.day}`;
  } catch (error: unknown) {
    console.error(error); // eslint-disable-line no-console
    return ''; // handle bad input
  }
};
